import React, { useEffect, useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TextField,
  Button,
  Select,
  MenuItem,
} from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import useLocalStorage from 'react-localstorage-hook';
import { Standard } from '@getvim/vim-connect';
import { isEmpty } from 'lodash-es';
import { EncounterUpdated } from '../../mocks/standard-events';
import { FlexBox } from '../common/FlexBox';
import { MonacoEditor } from '../monaco-editor';

export const EncounterUpdatedTab = () => {
  const [payload, setPayload] = useState<Standard.Events.EncounterUpdatedPayload>();
  const [predefinedPayload, setPredefinedPayload] = useState<string>('');
  const [lastUsedPayload, setLastUsedPayload] = useLocalStorage('lastEncounterUpdatedPayload', '');
  const [, setShouldPublish] = useLocalStorage('shouldPublishEncounterUpdated', false);

  useEffect(() => {
    handlePredefinedPayloadChange({ target: { value: lastUsedPayload } } as SelectChangeEvent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setShouldPublish(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePublish = () => setShouldPublish(true);

  const handlePredefinedPayloadChange = ({ target: { value } }: SelectChangeEvent) => {
    setPredefinedPayload(value);
    setLastUsedPayload(value);
    setPayload(EncounterUpdated.predefinedPayloads[value]);
  };

  return (
    <Accordion id="encounterUpdatedTab">
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>encounterUpdated</Typography>
        <Select
          displayEmpty
          value={predefinedPayload}
          id="encounter-updated-select"
          size="small"
          onChange={handlePredefinedPayloadChange}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <MenuItem value="">Choose</MenuItem>
          {Object.keys(EncounterUpdated.predefinedPayloads).map((value) => (
            <MenuItem
              value={value}
              key={value}
              id={`encounter-updated-${value.replaceAll(' ', '-')}`}
            >
              {value}
            </MenuItem>
          ))}
        </Select>

        <Button
          id="publish-encounter-updated"
          disabled={isEmpty(predefinedPayload)}
          fullWidth
          onClick={(e) => {
            e.stopPropagation();
            handlePublish();
          }}
          variant="contained"
        >
          Publish
        </Button>
      </AccordionSummary>
      <AccordionDetails>
        <MonacoEditor onChange={setPayload} height="20rem" value={payload} />

        <FlexBox>
          <TextField
            id="encounterUpdatedPayload"
            variant="outlined"
            size="small"
            value={JSON.stringify(payload)}
            sx={{ display: 'none' }}
          />
        </FlexBox>
      </AccordionDetails>
    </Accordion>
  );
};
